<template>
  <!-- width="17" height="17"  -->
  <path
    d="M4.25 8.50015L7.65 11.9001L13.6 5.10015"
    stroke="#2AAB6D"
    stroke-width="1.7"
    stroke-linecap="round"
  />
</template>
